module.exports = {"540322100":"莫洛镇","540322200":"敏都乡","540322201":"则巴乡","540322202":"罗麦乡","540322203":"沙东乡","540322204":"克日乡","540322205":"木协乡","540322206":"阿旺乡","540322207":"拉妥乡","540322208":"雄松乡","540322209":"哈加乡","540322210":"相皮乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540322.json
// module id = 2511
// module chunks = 0